// Block K (UI-22 Invoicing): the head of one Invoicing section (Invoices, Purchase orders, Expenses,
// Tax summary, Transactions). The page's own PageHeader ("Invoicing") and the section tabs are in
// InvoicingLayout; each section opens with this row: its name, one plain line of live context, and
// its create button on the right (full width on a phone, addendum 4).
import React from 'react';
import './invoicing.css';

export default function SectionHead({ title, subline, action, children }) {
  return (
    <div className="invc-head">
      <div className="invc-head__text">
        <h2 className="invc-head__title">{title}</h2>
        {subline && <p className="invc-head__sub">{subline}</p>}
        {children}
      </div>
      {action && <div className="invc-head__actions">{action}</div>}
    </div>
  );
}
